var _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgManageFields = function SvgManageFields(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    "data-name": "Laag 1",
    viewBox: "0 0 200 194.61",
    focusable: false,
    "aria-hidden": true
  }, props), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "manage_fields_svg2__a",
    x1: 21.18,
    x2: 193.65,
    y1: 178.81,
    y2: 6.34,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#3d43c1"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#a80096"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#manage_fields_svg2__a",
    id: "manage_fields_svg2__b",
    x1: 15.81,
    x2: 188.28,
    y1: 173.45,
    y2: 0.98
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#manage_fields_svg2__a",
    id: "manage_fields_svg2__c",
    x1: 27.06,
    x2: 199.53,
    y1: 184.69,
    y2: 12.22
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#manage_fields_svg2__a",
    id: "manage_fields_svg2__d",
    x1: -17.75,
    x2: 154.72,
    y1: 139.89,
    y2: -32.58
  }), /*#__PURE__*/React.createElement("linearGradient", {
    xlinkHref: "#manage_fields_svg2__a",
    id: "manage_fields_svg2__e",
    x1: 17.01,
    x2: 189.47,
    y1: 174.64,
    y2: 2.17
  }))), /*#__PURE__*/React.createElement("path", {
    d: "M198.66 20.14 179.87 1.38a4.744 4.744 0 0 0-6.69 0L106.76 67.8c-.5.52-.88 1.14-1.11 1.83l-9.82 28.56a4.76 4.76 0 0 0 1.14 4.89c.89.89 2.09 1.39 3.34 1.4.55 0 1.09-.08 1.61-.26l28.47-9.84c.68-.23 1.3-.62 1.8-1.14l66.42-66.43a4.747 4.747 0 0 0 .05-6.67m-72.23 65.52-.1.1-18.38 6.31 6.33-18.36 46.87-46.87.04.04.04-.04 12.05 12.05-46.85 46.78Zm53.49-53.49-12.05-12.05 8.66-8.68 12.05 12.07z",
    style: {
      fill: "url(#manage_fields_svg2__a)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M160.09 80.75c-2.62 0-4.74 2.12-4.74 4.74v99.63H9.49V28.56h121.24c2.62 0 4.74-2.12 4.74-4.74s-2.12-4.74-4.74-4.74H4.74C2.12 19.08 0 21.2 0 23.82v166.05c0 2.62 2.12 4.74 4.74 4.74h155.35c2.62 0 4.74-2.12 4.74-4.74V85.5c0-2.62-2.12-4.74-4.74-4.74Z",
    style: {
      fill: "url(#manage_fields_svg2__b)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M37.81 138.56c-8.01.01-14.5 6.5-14.52 14.52v2.37c.01 8.01 6.51 14.5 14.52 14.52h39.35c8.01-.01 14.5-6.51 14.52-14.52v-2.37c-.01-8.01-6.51-14.5-14.52-14.52zm44.38 14.51v2.37c0 2.78-2.25 5.03-5.03 5.03H37.81c-2.78 0-5.03-2.25-5.03-5.03v-2.37c0-2.78 2.25-5.03 5.03-5.03h39.35c2.78 0 5.03 2.25 5.03 5.03",
    style: {
      fill: "url(#manage_fields_svg2__c)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M105.11 56.96c2.62 0 4.74-2.12 4.74-4.74s-2.12-4.74-4.74-4.74H28.04c-2.62 0-4.74 2.12-4.74 4.74v23.96c0 2.62 2.12 4.74 4.74 4.74h59.82c2.62 0 4.74-2.12 4.74-4.74s-2.12-4.74-4.74-4.74H32.78V56.97h72.33Z",
    style: {
      fill: "url(#manage_fields_svg2__d)"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M141.52 121.22v-12.64c0-2.62-2.12-4.74-4.74-4.74s-4.74 2.12-4.74 4.74v7.9H32.78v-14.47h48.98c2.62 0 4.74-2.12 4.74-4.74s-2.12-4.74-4.74-4.74H28.04c-2.62 0-4.74 2.12-4.74 4.74v23.96c0 2.62 2.12 4.74 4.74 4.74h108.74c2.62 0 4.74-2.12 4.74-4.74Z",
    style: {
      fill: "url(#manage_fields_svg2__e)"
    }
  }));
};
export default SvgManageFields;